import type { PaperProps as IPaperProps } from '@mui/material';
import * as _ from 'lodash-es';
import { useState } from 'react';

import type { IUseTogglingOnHoverResult } from '../types';

export const useTogglingOnHover = (
  isPermanentlyOpen: boolean,
  shouldBeOpenOnHover: boolean
): IUseTogglingOnHoverResult => {
  const [isOpenedByHovering, setIsOpenedByHovering] = useState<boolean>(false);

  const handleHover = (isHovered: boolean) =>
    _.throttle(() => {
      if (!isPermanentlyOpen) {
        setIsOpenedByHovering(isHovered);
      }
    }, 500);

  const PaperProps: Partial<IPaperProps> = {
    onMouseEnter: handleHover(true),
    onMouseLeave: handleHover(false),
  };

  return {
    PaperProps: shouldBeOpenOnHover ? PaperProps : null,
    isOpenedByHovering,
  };
};
